import React from 'react'
import HWLog from './HWLog';

// This is for testing.
class HWLogsDisplay extends React.Component {

    constructor() {
        super();
        this.state = { displayLogs: HWLog.logLevel === HWLog.LogLevel.DEBUG }
        this.logs = [];
        this.logRef = React.createRef();
    }

    render() {
        return (<>
            {this.state.displayLogs && (<div ref={this.logRef} style={{ height: (window.screen.height * 0.79) +"px", width: "50%", background: "lightblue", overflow: "scroll" }}>
                <button style={{position:"absolute", marginLeft:"42%", marginTop:"10px"}} onClick={this.onCrear}>CLEAR LOG</button>
                <button style={{position:"absolute", marginLeft:"32%", marginTop:"10px"}} onClick={() => { localStorage.clear(); window.location.reload(); }}>CLEAR STORAGE</button>
                {this.logs.map((log, index) => {
                    return <div key={index + "-log"} style={{width:"90%", wordBreak:"break-all", paddingLeft:"10px"}}> {log.time} : {log.message} <br/> {log.logParams}<br/><br /></div>
                })}
            </div>)}
        </>
        );
    }

    componentDidMount() {
        window.addEventListener("message", this.onNewMessage, false);
    }

    onNewMessage = (message) => {
        try {
            let platformMessage = JSON.parse(message.data);
            if (platformMessage.logType) {
                this.logs.push(platformMessage);
                this.setState({ refreshState: "-" }, this.scrollToLatest);
            }
        } catch (error) { }
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.onNewMessage, false);
    }

    onCrear = () => {
        this.logs = [];
        this.setState({ refreshState: "-" }, this.scrollToLatest);
    }

    scrollToLatest = () => {
        this.logRef.current.scrollTop = this.logRef.current.scrollHeight;
    }

}

export default HWLogsDisplay;